import { Model } from "../../../types";
import { ModelManagementState } from "../types/models-types";

/**
 * Resets model management state
 */
export const resetModelState = (): ModelManagementState => ({
  isDrawerOpen: false,
  isDeleteModalOpen: false,
  editingModel: null,
  deletingModel: null,
});

/**
 * Opens edit drawer with model data
 */
export const openEditDrawer = (model: Model): ModelManagementState => ({
  editingModel: model,
  isDrawerOpen: true,
  isDeleteModalOpen: false,
  deletingModel: null,
});

/**
 * Opens create drawer
 */
export const openCreateDrawer = (): ModelManagementState => ({
  editingModel: null,
  isDrawerOpen: true,
  isDeleteModalOpen: false,
  deletingModel: null,
});

/**
 * Closes drawer
 */
export const closeDrawer = (): ModelManagementState => ({
  editingModel: null,
  isDrawerOpen: false,
  isDeleteModalOpen: false,
  deletingModel: null,
});

/**
 * Opens delete modal
 */
export const openDeleteModal = (model: Model): ModelManagementState => ({
  editingModel: null,
  isDrawerOpen: false,
  isDeleteModalOpen: true,
  deletingModel: model,
});

/**
 * Closes delete modal
 */
export const closeDeleteModal = (): ModelManagementState => ({
  editingModel: null,
  isDrawerOpen: false,
  isDeleteModalOpen: false,
  deletingModel: null,
});

/**
 * Gets drawer title based on editing state
 */
export const getDrawerTitle = (editingModel: Model | null): string => {
  return editingModel ? "Редактировать модель" : "Создать модель";
};

/**
 * Gets page title based on brand context
 */
export const getPageTitle = (brandName?: string): string => {
  return brandName ? `Модели ${brandName}` : "Модели";
};
